import {Tariffs} from './tariffs';
import {smartScannerFaq} from './smart-scanner-faq';

window.app.controller('bikFishCtrl', ['$scope', '$http', '$mdDialog', function ($scope, $http, $mdDialog) {
  $scope.applicationTime;
  $scope.partnerId = "8c3037b3-c7c4-4008-9e53-075da38660f5";
  $scope.dublicate = false;
  $scope.rejected = false;
  $scope.emailChecks = {};
  $scope.userMailAgentLink = "";
  $scope.userIsRegistrated = false;
  $scope.cards = Tariffs.cardsInfo;
  $scope.faqs = smartScannerFaq;
  $scope.firstRaport = false;

 $scope.partnerUrl = 'https://ekassa.pl';

  $scope.user = {
    firstName: "",
    lastName: "",
    phoneNumber: "",
    email: "",
    pesel: "",
    socialNumber: "",
    bankAccount: "",
    livPostcode: "",
    livCity: "",
    livStreet: "",
    livBuilding: "",
    livApartment: "",
    occupation: "",
    empType: "",
    accept_terms: "",
    accept_raport_personal_data_terms: "",
    accept_raport_mailing_policy: ""
  };

  class BikfishData {
    constructor(partnerId, firstName, lastName, pesel, socialNumber, accountNumber, email, phone,
                empType1, occupationType, livPostcode, livCity, livStreet, livBuilding, livApartment) {
      this.partnerId = partnerId;
      this.firstName = firstName;
      this.lastName = lastName;
      this.pesel = pesel;
      this.socialNumber = socialNumber;
      this.accountNumber = accountNumber;
      this.email = email;
      this.phone = phone.slice(3, phone.length);
      this.empType1 = empType1;
      this.occupationType = occupationType ? occupationType : "inne";
      this.livPostcode = livPostcode;
      this.livCity = livCity;
      this.livStreet = livStreet;
      this.livBuilding = livBuilding;
      this.livApartment = livApartment ? livApartment : "inne";
      this.firstRaport = $scope.firstRaport;
    }
  }

  $scope.checkPesel = () => {
    let regex = /\d{11}/gi;
    let match = regex.exec($scope.user.pesel);
    if (match !== null) {
      $http({
        method: 'POST',
        url: '/api/front/bik/bik-fish/check-pesel',
        data: $scope.user
      }).then(function successCallback(response) {
        if (response.data.is_available === false) {
          $scope.firstRaport = false;
          $scope.showWarn();
        }
      }, function errorCallback() {
        $scope.insertErrorText(`Ups, coś poszło nie tak. Spróbuj wysłać wniosek trochę później`);
      });
    }
  }

  $scope.showWarn = function (ev) {
    $mdDialog.show({
      template:
        '<md-dialog class="dialog-wide">' +
        '<div style="display: flex;flex-direction: column;margin-left: 20px;">' +
        '<p ng-click="closeModal()" class="close-modal">X</p>' +
        '<h2 style="margin-top: 20px;font-size: 20px">Otrzymaliście już raport za 1 złoty.</h2><br>' +
        '<div style="margin: 0px 5px 15px 5px;">' +
        'Dostępne są tylko standardowe stawki: ' +
        '<ul><br>' +
        '<li style="list-style-type: circle">raport do wyboru BIK lub CRIF za 29 PLN.</li><br>' +
        '<li style="list-style-type: circle">połączony raport z BIK i CRIF za jedyne 39 zł.</li><br>' +
        '</ul><br>' +
        '<div style="display: flex; justify-content: center"><button ng-click="closeModal()" class="buttonModal">Kontynuuj składanie wniosku</button></div>' +
        '</div>' +
        '</div>' +
        '</md-dialog>',
      parent: angular.element(document.body),
      targetEvent: ev,
      clickOutsideToClose: true,
      fullscreen: $scope.customFullscreen, // Only for -xs, -sm breakpoints.
      controller: function DialogController($scope, $mdDialog) {
        $scope.closeModal = function () {
          $mdDialog.hide();
        }
      }
    })
  };

  $scope.setFirstRaport = () => {
    $scope.sendXHR({
      url: `/api/front/bik/bik-fish/check-pesel`,
      headers: {'Content-Type': 'application/json'},
      data: $scope.formUserData(),
      dataAsParam: false,
      method: 'POST',
      successFunc: $scope.firstReport,
      errorFunc: $scope.handleError,
    }, false);
  }

  $scope.firstReport = (resp) => {
    if(resp.data.is_available == true) {
      $scope.firstRaport = true;
    } else {
      $scope.firstRaport = false;
    }
  }

  $scope.flipCard = (index) => {
    $(`.flip-card.${index}`).toggleClass("fliped");
  }

  $scope.setUpCarousel = () => {
    $('.owl-bik-tariffs').owlCarousel({
      loop: false,
      dots: false,
      nav: false,
      autoplay: false,
      pagination: false,
      autoplayHoverPause: true,
      mouseDrag: false,
      // responsiveRefreshRate: 200,
      items: 3,
      margin: 50,

      responsive: {
        0: {
          items: 1,
          dots: true,
          pagination: true,
          loop: true,
          mouseDrag: true,
        },
        576: {
          dots: true,
          pagination: true,
          items: 1,
          loop: true,
        },
        992: {
          items: 3,
          loop: false
        }
      }
    });
  }

  $(".trigger").click(function () {
    $("#trigger-form").show('open-form');
    $scope.scrollTo("#trigger-form");
    $(".first-input")[0].focus();
  });

  $(".faqS-triger").click(function () {
    $scope.scrollTo("#faq6");
    $scope.faqOpen("#faq6");
  });


  $(".faqN-triger").click(function () {
    $scope.scrollTo("#faq7");
    $scope.faqOpen('#faq7');
  });

  $scope.faqOpen = (id) => {
    if ($(id).hasClass("open")) {
      return;
    } else {
      $(id).toggleClass('open').next('.faq_text').slideToggle();
    }
  }


  $scope.submitForm = () => {
    $scope.userMailAgentLink = `http://${$scope.user.email.split('@')[1]}`;
    $scope.userIsRegistrated = $scope.emailChecks[$scope.user.email].data.userExists;
    $scope.emailChecks[$scope.user.email].data.emailConfirmed === 0 ? $scope.resendRegConfirmLetter() : "";
    $scope.sendUserData();
  }

  $scope.submitForm = () => {
    $scope.userMailAgentLink = `http://${$scope.user.email.split('@')[1]}`;
    $scope.userIsRegistrated = $scope.emailChecks[$scope.user.email].data.userExists;
    $scope.emailChecks[$scope.user.email].data.emailConfirmed === 0 ? $scope.resendRegConfirmLetter() : "";
    $scope.sendUserData();
  }

  $scope.formUserData = () => {
    $scope.profileData = Object.assign({}, $scope.user);
    $scope.profileData.accept_terms = $scope.profileData.accept_terms ? "1" : "0";
    $scope.profileData.accept_raport_personal_data_terms = $scope.profileData.accept_raport_personal_data_terms ? "1" : "0";
    $scope.profileData.accept_raport_mailing_policy = $scope.profileData.accept_raport_mailing_policy ? "1" : "0";
    delete $scope.profileData.occupation;
    delete $scope.profileData.empType;
    return $scope.profileData
  }

  $scope.sendUserData = () => {
    $http({
      method: 'POST',
      url: '/api/front/application/save-application/save',
      data: $scope.formUserData()
    }).then(function successCallback() {
      $scope.sendBik();
    }, function errorCallback() {
      $scope.insertErrorText(`Ups, coś poszło nie tak. Spróbuj wysłać wniosek trochę później`);
    })
  }

  $scope.sendLink = (partner_id) => {
    $http({
      method: 'POST',
      url: '/api/front/bik/bik-fish/link',
      data: {
        email: $scope.user.email,
        link: `${$scope.partnerUrl}/#/?raport_id=${partner_id}`,
        occupation: $scope.user.occupation,
        empType: $scope.user.empType,
        firstRaport: $scope.firstRaport,
        pesel: $scope.user.pesel
      }
    }).then(function successCallback() {
      //ga('send', 'event', 'Application_report', 'click');
      $scope.showSuccessPopUp($scope.userMailAgentLink);
      var ekassaWin = window.open(`${$scope.partnerUrl}/#/?raport_id=${partner_id}`);
      if (!ekassaWin) {
        //POPUP BLOCKED
        window.location.href = `${$scope.partnerUrl}/#/?raport_id=${partner_id}`;
      }
    }, function errorCallback() {
      $scope.insertErrorText(`Ups, coś poszło nie tak. Spróbuj wysłać wniosek trochę później`);
    })
  }

  $scope.sendLog = (data) => {
    $scope.sendXHR({
      url: `/api/front/bik/bik-log/log`,
      data: data
    });
  }

  $scope.sendBik = () => {
    let data = new BikfishData($scope.partnerId, $scope.user.firstName, $scope.user.lastName, $scope.user.pesel,
      $scope.user.socialNumber, $scope.user.bankAccount, $scope.user.email, $scope.user.phoneNumber, $scope.user.empType, $scope.user.occupation,
      $scope.user.livPostcode, $scope.user.livCity, $scope.user.livStreet, $scope.user.livBuilding, $scope.user.livApartment);
    $scope.sendLog(data);
    $scope.sendXHR({
      url: `/api/front/bik/bik-fish/send-data`,
      headers: {'Content-Type': 'application/json'},
      data: data,
      dataAsParam: false,
      method: 'POST',
      successFunc: $scope.handlePartnerResponse,
      errorFunc: $scope.handleError,
    }, true, ".bikFishLoader")
  };

  $scope.handlePartnerResponse = (resp) => {
    $scope.sendLog(resp.data);
    if (resp.data) {
      let error = resp.data.Status ? resp.data.Status : JSON.stringify(resp.data);
      if(resp.data.unique_partner_id) {
        let partner_id = resp.data.unique_partner_id;
        $scope.insertErrorText = "";
        $scope.sendLink(partner_id);
      } else if (resp.data.Status === "RISK_POLICY_REJECT") {
        $scope.rejected = true;
        $scope.sendError(error)
      } else if (resp.data.Status === "DUPLICATE_REQUEST") {
        $scope.dublicate = true;
        $scope.sendError(error)
      } else {
        $scope.generateValidError(resp.data);
        $scope.sendError(error)
      }
    } else {
      $scope.insertErrorText(`Ups, coś poszło nie tak. Spróbuj wysłać wniosek trochę później`);
      $scope.sendError("TECH_ERROR");
    }
  }

  $scope.handleError = () => {
      $scope.insertErrorText(`Ups, coś poszło nie tak. Spróbuj wysłać wniosek trochę później`);
  }

  $scope.sendError = (error) => {
    $http({
      method: 'POST',
      url: '/api/front/bik/bik-fish/link',
      data: {
        email: $scope.user.email,
        link: error,
        occupation: $scope.user.occupation,
        empType: $scope.user.empType,
        firstRaport: $scope.firstRaport,
        pesel: $scope.user.pesel
      }
    })
  }

  $scope.propertiesToPl = {
    firstName: "IMIĘ",
    lastName: "NAZWISKO",
    socialNumber: "NR DOWODU OSOBISTEGO",
    accountNumber: "NUMER KONTA BANKOWEGO",
    email: "LOGIN (E-MAIL)",
    phone: "TELEFON KOMÓRKOWY",
    empType1: "FORMA ZATRUDNIENIA",
    occupationType: "ZAWÓD WYKONYWANY",
    livPostcode: "KOD POCZTOWY",
    livCity: "MIASTO",
    livStreet: "ULICA",
    livBuilding: "NUMER BUDYNKU",
    livApartment: "NUMER MIESZKANIA"
  }

  $scope.insertErrorText = (str) => {
    $(".error-space").text(str)
  }

  $scope.generateValidError = (errorObj) => {
    let invalidInputs = "";
    for (let key in errorObj) {
      invalidInputs += `${$scope.propertiesToPl[key]}, `
    }
    $scope.insertErrorText(`Prawdopodobnie w danych zawartych we wniosku występują błędy. Sprawdź swoje dane: ${invalidInputs} wprowadź zmiany i ponownie wyślij wniosek`)
  }

  $(document).ready(function () {
    $(".check-label").click(function () {
      this.removeAttribute("style")
    })
    $scope.setUpCarousel();
    // $(".point-img").html(`<img alt="${$scope.bikPoints[0].title}" src='${$scope.bikPoints[0].img}'></img>`);
    // $(".point-text").html($scope.bikPoints[0].text);
    // $(".point-title").html($scope.bikPoints[i].title);
  });

  $scope.resendRegConfirmLetter = () => {
    return $http({
      method: 'POST',
      url: '/api/front/registration/registration/resend-letter',
      data: {
        type: 'user',
        email: $scope.user.email
      }
    });
  };

  $scope.showSuccessPopUp = (userMailAgentLink) => {
    $mdDialog.show({
      preserveScope: true,
      template:
        `<div id="modal-popup">
                      <div class="layout" layout-align="end">
                      <span class="modal-close-btn" ng-click="finishProcess()" aria-label="close">X</span>
                      </div>
                      <p class="title text-center">
                        Dziękujemy za wniosek.
                        <span ng-if="!${$scope.userIsRegistrated}">
                            <br><br> 
                            Przejdź na pocztę <a target="_blank" href=${userMailAgentLink} class="mail-agent-link">${$scope.user.email}</a> i potwierdź rejestrację na stronie Racoongo.com
                        </span>
                      </p>
                  </div>`,
      parent: angular.element(document.body),
      scope: $scope,
    });
  }

  $scope.finishProcess = () => {
    $scope.closeDialog();
    window.location.reload();
  }

  $scope.bikPoints = [
    {
      class: "first",
      text: "Tutaj zobaczysz wszystkie pożyczki zebrane w jednej tabeli - ekran tabeli",
      img: "/front/src/img/bikfish/first-point.png",
      title: "Informacje o wszystkich pożyczkach"
    },
    {
      class: "second",
      text: "Tutaj zobaczysz wszystkie wnioski o pożyczkę zebrane w jednej tabeli - na ekranie tabeli",
      img: "/front/src/img/bikfish/second-point.png",
      title: "Informacje o wszystkich wnioskach o pożyczki"
    },
    {
      class: "third",
      text: "Wyjaśnimy szczegółowo i jasno na podstawie informacji, jakie kredytodawcy podejmują decyzję o udzieleniu pożyczki. I na ile kredytodawcy widzą cię jako swojego klienta - przykładowy tekst",
      img: "/front/src/img/bikfish/point5.png",
      title: "Szczegółowa analiza wszystkich pożyczek"
    },
    {
      class: "forth",
      text: "Pokażemy dokładnie w jaki sposób możesz zmienić swoją historię kredytową i zacząć uzyskiwać najlepsze warunki kredytowe - przykładowy tekst",
      img: "https://via.placeholder.com/150",
      title: "Spersonalizowane rekomendacje"
    },
    {
      class: "fifth",
      text: "Wydamy zalecenia dotyczące planowania i zarządzania swoimi finansami - zdjęcie z harmonogramem",
      img: "https://via.placeholder.com/150",
      title: "Analiza obciążenia finansowego"
    }
  ];

  $(".points-titles > button").click(function () {
    let iemClass = $(this).attr('class');
    for (let i = 0; i < $scope.bikPoints.length; i++) {
      if (iemClass === $scope.bikPoints[i].class) {
        $(".point-img").html(`<img class="bik-point-img" alt="${$scope.bikPoints[i].title}" src='${$scope.bikPoints[i].img}'>`);
        $(".point-text").html($scope.bikPoints[i].text);
        $(".point-title").html($scope.bikPoints[i].title);
      }
    }
    // $(`.${title}.desc`).show("slide", { direction: "right" });
  })

  $(document).ready(function () {
    $(".regulamin ~ .check-text").click(function () {
      $scope.setClick(".regulamin");
      ($("#regulamin").prop("checked")) ? $scope.user.accept_terms = true : $scope.user.accept_terms = false;
    });
    $(".agreement-policy ~ .check-text").click(function () {
      $scope.setClick(".agreement-policy");
      ($("#agreement-policy").prop("checked")) ? $scope.user.accept_raport_personal_data_terms = true : $scope.user.accept_raport_personal_data_terms = false;
    });
    $(".agreement-data ~ .check-text").click(function () {
      $scope.setClick(".agreement-data");
      ($("#agreement-data").prop("checked")) ? $scope.user.accept_raport_mailing_policy = true : $scope.user.accept_raport_mailing_policy = false;
    });
  });

}])



// WEBPACK FOOTER //
// src/js/controllers/bikfish/bikFishCtrl.js